<template>

  <div class="height-100">
    
    <creating
      v-if="creating"
      height="100%" />

    <div
      class="vflex"
      v-if="!creating">

      <div class="vflex-row-0 vflex-header" style="border: 0">
        <div class="p-3">
          <job-header></job-header>
        </div>
        <ul class="nav nav-tabs">
          <li
            class="nav-item pl-3">
            <router-link
              class="nav-link"
              :class="{'active': $route.name === 'job.board'}"
              :to="{path: '/job/' + job._id}">
              {{ $t('Pipeline') }}
              </router-link>
          </li>
          <li
            class="nav-item">
            <router-link
              class="nav-link"
              :class="{'active': $route.name === 'job.grid'}"
              :to="{path: '/job/' + job._id + '/grid'}">
              {{ $t('Filters') }}
              </router-link>
          </li>
          <!--
          <li
            class="nav-item">
            <router-link
              class="nav-link"
              :class="{'active': $route.name === 'job.recommended'}"
              :to="{path: '/job/' + job._id + '/recommended'}">
              Recomendados
              </router-link>
          </li>
          -->
          <li
            class="nav-item">
            <router-link
              class="nav-link"
              :class="{'active': $route.name === 'job.report'}"
              :to="{path: '/job/' + job._id + '/report'}">
              {{ $t('Report') }}
              </router-link>
          </li>
          <li
            class="nav-item">
            <router-link
              class="nav-link"
              :class="{'active': $route.name === 'job.log'}"
              :to="{path: '/job/' + job._id + '/log'}">
              {{ $t('History') }}
              </router-link>
          </li>
          <li
            class="nav-item">
            <router-link
              class="nav-link"
              :class="{'active': $route.name === 'job.attach'}"
              :to="{path: '/job/' + job._id + '/attach'}">
              {{ $t('Files') }}
              </router-link>
          </li>
          <li
            v-if="permissions.includes('promote_job')"
            class="nav-item">
            <router-link
              class="nav-link"
              :class="{'active': $route.name === 'job.advertise'}"
              :to="{path: '/job/' + job._id + '/advertise'}">
              {{ $t('Advertise') }}
              </router-link>
          </li>
          <li
            v-if="account.sampleRhevolut"
            class="nav-item">
            <router-link
              class="nav-link"
              :class="{'active': $route.name === 'job.rhevolut'}"
              :to="{path: '/job/' + job._id + '/rhevolut'}">
              {{ $t('Rhevolut') }}
              </router-link>
          </li>
          <li class="nav-item">
            <router-link
              class="nav-link"
              :class="{'active': $route.name === 'job.profile'}"
              :to="{path: '/job/' + job._id + '/profile'}">
              {{ $t('Profile') }}
              </router-link>
          </li>
          <!--
          <li class="nav-item">
            <router-link
              class="nav-link"
              :class="{'active': $route.name === 'job.approvalflow'}"
              :to="{path: '/job/' + job._id + '/approvalflow'}">
              {{ $t('Approval flow') }}
              </router-link>
          </li>
          -->
        </ul>
      </div>

      <div class="vflex-row-1">
        <router-view></router-view>
      </div>

    </div>

  </div>

</template>

<script>
import JobHeader from './JobHeader/JobHeader'

export default {
  name: 'Job',
  components: {
    JobHeader
  },
  data () {
    return {
      creating: true
    }
  },
  computed: {
    account () {
      return this.$store.getters.getAccount
    },
    permissions () {
      return this.$store.getters.getPermissions
    },
    jobId () {
      return this.$route.params.id
    },
    job () {
      return this.$store.getters.getJob
    }
  },
  metaInfo () {
    return {
      title: this.creating ? 'Carregando...' : this.job.title
    }
  },
  watch: {
    jobId (value) {
      this.creating = true
      this.loadData()
    }
  },
  created () {
    this.loadData()
  },
  methods: {
    /*
    loadData
    */
    loadData () {
      Promise.all([
        this.$store.dispatch('selectJob', this.jobId),
        this.$store.dispatch('selectStages'),
        this.$store.dispatch('selectDisqualifyReasons', {sort: 'name', limit: 2000}),
        this.$store.dispatch('selectCancelReasons', {sort: 'name'})
      ])
      .then(() => {
        this.creating = false
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Job/Job.vue